<template>
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true'>
					<el-form-item label="关键字：" >
						<el-input placeholder="发票抬头/姓名/手机号" v-model="filters.keyWord" clearable></el-input>
					</el-form-item>
					<el-form-item label="缴费时间：" >
						<el-date-picker 
						v-model="filters.payTime" 
						:unlink-panels="true" 
						type="daterange" 
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						range-separator="至" 
						start-placeholder="开始日期"
						 end-placeholder="结束日期" 
						 style="margin-left: 10px;width: 260px;">
						 </el-date-picker>
					</el-form-item>
				
					<el-form-item  label="是否已开票：">
						<el-select v-model="filters.invoiceStatus" placeholder="请选择" clearable>
							<el-option
									v-for="item in invoiceStatus"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item  label="是否启用：">
						<el-select v-model="filters.isEnable" placeholder="请选择" clearable>
							<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!-- 列表 -->
		<el-table
				:data="tableData"
				ref="multipleTable"
				border
				style="width: 100%"
				v-loading="listLoading"
				@current-change='currentChange'
				 @selection-change="handleSelectionChange"
				:highlight-current-row='true'
				show-summary
				  :summary-method="getSummaries" 
		>
			<el-table-column type="selection" align="center" :selectable="selectable"  width="60"></el-table-column>
			<el-table-column prop="Name" label="姓名" width="120" align="center"></el-table-column>
			<el-table-column prop="PhoneNumber" label="手机号" width="" align="center"></el-table-column>
			<el-table-column prop="PayTime" label="缴费时间" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceStatus" label="是否已开票" width="" align="center">
				<template slot-scope="scope">
				<el-tag type="danger" v-if="scope.row.InvoiceStatus==0">未开票</el-tag>
				<el-tag type="warning" v-if="scope.row.InvoiceStatus==1">开票中</el-tag>
				<el-tag type="success" v-if="scope.row.InvoiceStatus==2">已开票</el-tag>
				<el-tag type="success" v-if="scope.row.InvoiceStatus==4">已红冲</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="InvoiceMoney" label="已开票金额" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceCreateTime" label="开票时间" width="" align="center"></el-table-column>
			<el-table-column prop="LearnTime" label="学习课时" width="" align="center"></el-table-column>
			<el-table-column prop="Tuition" label="学费收款" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceTitle" label="发票抬头" width="" align="center"></el-table-column>
			<el-table-column prop="CompanyTaxNumber" label="信用代码" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceNumber" label="发票号" width="" align="center"></el-table-column>

		</el-table>
		<!--底部工具条-->
		<el-col :span="24" class="pageBar" style="height: 80px;margin-top: 12px">
			<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageIndex"
					:page-sizes="pages.pageArr"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages.dataCount">
			</el-pagination>
		</el-col>
		<el-dialog
            title="开票申请"
            :visible.sync="issueInvoiceDialog"
            v-model="issueInvoiceDialog"
            :close-on-click-modal="false"
			
        >
		
	 		<el-form :model="formItem" :rules="FormRules" ref="FormRef" label-width="150px"  v-for="(formItem, index) in FormList"  :key="index">
				<el-form-item :label="'发票信息' + (index + 1)"></el-form-item>
                <el-form-item label='发票类型:' >
                     <el-radio-group v-model="formItem.InvoiceType">
                        <el-radio :label="62">电子普票</el-radio>
                        <el-radio :label="61">电子专票</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label='发票抬头:'>
                     <el-radio-group v-model="formItem.InvoiceTitleType">
                        <el-radio :label="2">个人</el-radio>
                        <el-radio :label="1">公司</el-radio>
                    </el-radio-group>
                </el-form-item>
				 
                <el-form-item label='抬头名称:'>
                    <el-input style="width:300px" v-model='formItem.InvoiceTitle' clearable></el-input>
                </el-form-item>
				<el-form-item label='公司税号:' v-if="formItem.InvoiceTitleType==1" prop="CompanyTaxNumber">
                   <el-input style="width:300px" v-model='formItem.CompanyTaxNumber' clearable placeholder="请输入公司税号"></el-input>
                </el-form-item>
				<el-form-item label='开票金额:'>
                    <!-- <el-input  style="width:300px" v-model='Form.InvoiceMoney' clearable></el-input> -->
					<span>{{formItem.InvoiceMoney}}</span>
					<span style="margin-left:5px;">元</span>
                </el-form-item>
				<el-form-item label='开票备注:' >
                    <el-input style="width:300px" v-model='formItem.InvoiceRemark' clearable placeholder="请输入开票备注"></el-input>
                </el-form-item>
				  <el-divider v-if="index != FormList.length"></el-divider>
			</el-form>
			<div>
				<span>开票金额汇总：{{sumWaitInvoiceAmount}}元</span>
			</div>
			 
			<div slot="footer" class="dialog-footer">
                <el-button @click.native="issueInvoiceDialog = false">取消</el-button>
                <el-button type="primary" @click.native="FormSubmit" :loading="listLoading">确认开票</el-button>
            </div>
		 </el-dialog>		
	</div>

</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import { getReceiptOfAppListPage,exportReceiptOfAppInfoData,applyLeQiInvoice} from '@/api/api'
export default {
	components:{Toolbar},
	data() {
		return {
			buttonList: [],
			filters:{
				keyWord:undefined,//关键字
				payTime:undefined,
				invoiceStatus:undefined,//开票状态：（0：未开、1：开票中、2：已开票）
				isEnable:1
			},
			tableData: [],
			invoiceStatus:[
				{
					label:'未开票',
					value:0
				},
				{
					label:'开票中',
					value:1
				},
				{
					label:'已开票',
					value:2
				},
				{
					label:'已红冲',
					value:4
				}
			],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			issueInvoiceDialog:false,
			FormList:[],
			// Form:{
            //     InvoiceType:62,
            //     InvoiceTitleType:2,
            //     InvoiceTitle:"",
            //     InvoiceMoney:"",
            //     InvoiceRemark:"",
            //     CompanyTaxNumber:""
            // },
			FormRules:{
				CompanyTaxNumber:[{ required: true, message: '请输入公司税号', trigger: 'blur' }],
			
			},
			totalData:"",
			selectedRow:"",
			options: [
				{ value: 1, label: "已启用" },
				{ value: 0, label: "未启用" },
      		],
			sumWaitInvoiceAmount:0
			
		}
	},
	methods: {
		// 自定义合计逻辑
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
            // 1. 第一列显示“合计”文字
            if (index === 0) {
                sums[index] = '合计';
                return;
            }

            // 2. 找到“已开票金额”这一列（根据 prop 属性匹配）
            if (column.property === 'InvoiceMoney') {
                // 显示后台返回的合计值，如果没有则显示 0
                sums[index] = this.totalData.InvoiceMoneyTotal || 0;
                return;
            }
            // 3. 找到“学费收款”这一列（根据 prop 属性匹配）
            if (column.property === 'Tuition') {
                // 显示后台返回的合计值，如果没有则显示 0
                sums[index] = this.totalData.ReceiptTotal || 0;
                return;
            }
            // 4. 其他所有列都显示为空
            sums[index] = '';
        });
        return sums;
    },
		selectable(row){
			if(row.InvoiceStatus == 0 || row.InvoiceStatus == 4){
				return true
			}else{
				return false
			}
		},
		callFunction(item) {
			this[item.Func].apply(this, item);
		},
		issueInvoice(){
			console.log('this.selectedRow',this.selectedRow)
			if (this.selectedRow.length==0 ) { 
				this.$message.warning("请先勾选需要开票的人员");
				return;
        	}
			var count = 0;
			this.selectedRow.map(item=>{
				count +=item.Tuition
			})
			this.sumWaitInvoiceAmount = count;
			// this.Form = {
			// 	InvoiceType:62,
			// 	InvoiceTitleType:2,
			// 	InvoiceTitle:this.currentRow.Name,
			// 	InvoiceMoney:this.currentRow.Tuition,
			// 	InvoiceRemark:"",
			// 	CompanyTaxNumber:""
			// }
			this.FormList = this.selectedRow.map(row => {
				return {
					// 基础字段
					InvoiceType: 62, // 默认电子普票
					InvoiceTitleType: 2, // 默认个人
					InvoiceTitle: row.Name, // 默认填入姓名
					InvoiceMoney: row.Tuition, // 金额
					InvoiceRemark: "", // 备注清空
					CompanyTaxNumber: "", // 税号清空
				    OrderInfoId:row.OrderInfoId,
				    StudentLearnRecordId:row.StudentLearnRecordId,
					PhoneNumber:row.PhoneNumber,
					OrderCode:row.OrderCode,
					Email:'',
					ApplyInvoicesource:1,
					IsCheckReceiverInfo:false

				}
  			});
			 	// 等待 DOM 渲染完成再调用 clearValidate
				 this.$nextTick(() => {
					if (this.$refs.FormRef) {
						// 如果有多个表单，refs 是一个数组，需要遍历清空
						this.$refs.FormRef.forEach(form => {
							if(form){
								form.clearValidate();
							}
						});
					}
  				});	
				this.issueInvoiceDialog = true
		},
		getDataList(){
			this.listLoading = true
			const{ payTime,...Restparams} = this.filters
			let params = {
				...Restparams,
				payStartTime:payTime? payTime[0] + ' ' +'00:00:00': undefined,
				payEndTime:payTime? payTime[1] + ' ' + '00:00:00': undefined,
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
			}
			getReceiptOfAppListPage(params).then(res => {
				var result = res.data
				if(result.Success){
					this.listLoading = false;
					this.pages.dataCount = result.Response.ReceiptList.DataCount
					this.tableData = result.Response.ReceiptList.Data
					this.totalData=result.Response.ReceiptTotal
				}else{
					this.listLoading = false
				}
			})
		},
		FormSubmit(){
			const formRefs = this.$refs.FormRef;
			const validatePromises = formRefs.map(formRef => {
				return formRef.validate().catch(err => {
					return false; 
				});
    		});
			Promise.all(validatePromises).then(results => {
				const isAllValid = results.every(valid => valid === true);
				if (isAllValid) {
					let params = this.FormList;
					this.listLoading = true; 
					applyLeQiInvoice(params).then(res => {
						this.listLoading = false;
						if (res.data.Success) {
							this.$message.success(res.data.Message);
							this.issueInvoiceDialog = false;
							this.getListData(); 
						} else {
							this.$message.error(res.data.Message);
						}
					}).catch(() => {
						this.listLoading = false;
					});
				}
			});
			// this.$refs.FormRef.validate((valid) => {
			// 	if(valid){
			// 		let params = this.FormList
			// 		applyLeQiInvoice(params).then(res=>{
			// 			if(res.data.Success){
			// 				this.$message.success(res.data.Message)
			// 				this.issueInvoiceDialog = false
			// 			}else{
			// 				this.$message.error(res.data.Message)
			// 			}			
			// 		})
			// 	}
			// })
		},

		// 查询
		getListData() {
			this.pages.pageIndex = 1
			this.pages.pageSize = 20
			this.getDataList();
		},
		// 导出
		export(){
			this.listLoading = true
			const{ payTime,...Restparams} = this.filters
			let params = {
				...Restparams,
				payStartTime:payTime? payTime[0] + ' ' +'00:00:00': undefined,
				payEndTime:payTime? payTime[1] + ' ' + '00:00:00': undefined
			}
			exportReceiptOfAppInfoData(params).then(res=>{
				this.handleFileDownload(res)
			})
		},
		handleFileDownload(response) {
			const fileName = 'app收款明细.xlsx'
			// 创建Blob对象
			let blob = new Blob([response.data], {type: "content-type"})

			// 创建临时链接并触发下载
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			link.style.display = 'none';

			document.body.appendChild(link);
			link.click();

			// 清理资源
			document.body.removeChild(link);
			window.URL.revokeObjectURL(link.href);
			this.listLoading = false
		},
		handleSelectionChange(val){
			this.selectedRow = val
			console.log('val',val)
		},
		// 点击table某一行
		currentChange(val) {
			
		},

		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row.CreateTime || row.CreateTime == ""
					? ""
					: util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
		},
		
		
	
	},
	watch: {

	},
	created(){
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getListData()
	},
	mounted() {
		
	}
}
</script>

<style lang="stylus" scoped>

</style>
